import React from 'react';

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; error?: Error; errorInfo?: React.ErrorInfo }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error);
    console.error('Component stack:', errorInfo.componentStack);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 20, fontFamily: 'monospace', backgroundColor: '#fee', border: '1px solid #f88' }}>
          <h2>Something went wrong.</h2>
          <details>
            <summary>Error Details</summary>
            <pre style={{ whiteSpace: 'pre-wrap', color: '#d00' }}>
              {this.state.error?.name}: {this.state.error?.message}
              {'\n\n'}
              {this.state.error?.stack}
              {'\n\n'}
              Component Stack:
              {this.state.errorInfo?.componentStack}
            </pre>
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}
